import React, { useEffect, useRef, useState } from 'react';

interface Props {
  price: number;
  productName: string;
  inStock: boolean;
  watchRef?: React.RefObject<HTMLElement>;
  onAddToCart: () => void;
}

const ProductStickyCart: React.FC<Props> = ({ price, productName, inStock, watchRef, onAddToCart }) => {
  const [visible, setVisible] = useState(false);
  const internalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const target = watchRef?.current || internalRef.current;
    if (!target) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        // bar visible when original CTA out of viewport
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0 }
    );
    obs.observe(target);
    return () => obs.disconnect();
  }, [watchRef]);

  return (
    <>
      {/* anchor pro IntersectionObserver, pokud nemáme externí ref */}
      {!watchRef && <div ref={internalRef} className="pd-sticky-anchor" />}
      <div className={`pd-sticky-cart${visible ? ' is-visible' : ''}`} aria-hidden={!visible}>
        <div className="pd-sticky-cart__info">
          <div className="pd-sticky-cart__name">{productName}</div>
          <div className="pd-sticky-cart__price">{price.toLocaleString('cs-CZ')} Kč</div>
        </div>
        <button
          type="button"
          className="pd-sticky-cart__btn"
          onClick={onAddToCart}
          disabled={!inStock}
        >
          {inStock ? 'Do košíku' : 'Vyprodáno'}
        </button>
      </div>
    </>
  );
};

export default ProductStickyCart;
